import React, { useState } from 'react';

const ActionsForm = ({ json_actions, t_activator_actions_fromForm }) => {
  const [formValues, setFormValues] = useState(
    json_actions.reduce((acc, action) => {
      acc[action.code] = ""; // Initialize each action with an empty string
      return acc;
    }, {})
  );

  const handleChange = (actionCode, value) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      [actionCode]: value,
    }));
  };
  

  const handleSubmit = (e) => {
    e.preventDefault();
    //console.log("Submitted Values:", formValues);
    t_activator_actions_fromForm(formValues);

    // Reset form values
    const updatedObject = Object.fromEntries(
      Object.entries(formValues).map(([key]) => [key, ''])
    );
    setFormValues(updatedObject);
  };

  return (
    <form onSubmit={handleSubmit}>
      <table className="table">
        <thead>
          <tr>
            <th>Code</th>
            <th>Target</th>
            <th>Input</th>
          </tr>
        </thead>
        <tbody>
          {json_actions.map((action) => (
            <tr key={action.code}>
              <td>{action.code}</td>
              <td>{action.target}</td>
              <td>
                {/* Render integer values as a dropdown */}
                {action.options?.length > 0 && (
                  <select
                    className="form-select w-50" // Ensure full width
                    value={formValues[action.code]}
                    onChange={(e) => handleChange(action.code, e.target.value)}
                  >
                    <option value="">Select</option>
                    {action.options.map((v) => (
                      <option key={v.value} value={v.value}>
                        {v.inputtarget}
                      </option>
                    ))}
                  </select>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <button type="submit" className="btn btn-primary">Submit</button>
    </form>
  );
};

const ActionComposer = (props) => {
  const { selectedDev, t_activator_actions_fromForm } = props;
  const json_actions = selectedDev.requestData?.actions;
  if (!json_actions || json_actions.length === 0) return <></>;

  return (
    <div className="container mt-5">
      <div className="card">
      {/* <div className="card-header">
            <h4>Action Form</h4>
        </div> */}
        <h4>Action Form</h4>
      <ActionsForm 
        json_actions={json_actions} 
        t_activator_actions_fromForm={t_activator_actions_fromForm}
      />
      </div>
    </div>
  );
};

export default ActionComposer;